import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="text-center">
        <div className="text-6xl font-bold text-slate-300">404</div>
        <h1 className="text-xl font-semibold mt-2">Page not found</h1>
        <p className="text-slate-500 mt-1">The page you're looking for doesn't exist.</p>
        <Link to="/dashboard" className="btn-primary mt-4 inline-block">Go to dashboard</Link>
      </div>
    </div>
  );
}
